import { createSlice } from "@reduxjs/toolkit";

const globalVariableSlice = createSlice({
    name:"globalVariables",
    initialState:{
        screenType:"general"
    },
    reducers:{
        setScreenType(state,action){
            state.screenType = action?.payload;
        },
    }
})


export const {setScreenType} = globalVariableSlice.actions
export default globalVariableSlice.reducer